import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.notion.page');
import { OnInit, Input, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-notion-page',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.widget.notion.page/view.scss */
:host {
  display: block;
  width: 100%;
}

.notion-page-root {
  width: 100%;
}

.notion-workspace {
  display: grid;
  grid-template-columns: minmax(260px, 320px) minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}
.notion-workspace.is-editing {
  grid-template-columns: minmax(220px, 280px) minmax(0, 1fr);
}

.notion-list-pane {
  position: sticky;
  top: 24px;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  padding-right: 2px;
}

.notion-list-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.notion-list-stack {
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.notion-list-item {
  display: block;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #f4f4f5;
  background: #fff;
  padding: 12px 14px;
  cursor: pointer;
  transition: background 0.12s, box-shadow 0.12s;
}
.notion-list-item:last-child {
  border-bottom: none;
}
.notion-list-item:hover {
  background: #fafafa;
}
.notion-list-item.active {
  background: #eff6ff;
  box-shadow: inset 3px 0 0 #2563eb;
}

.notion-list-empty,
.notion-detail-empty {
  display: flex;
  min-height: 320px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.notion-detail-pane {
  min-height: 560px;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
}
.notion-detail-pane.is-editing {
  min-height: 760px;
}

.notion-detail-toolbar,
.notion-edit-toolbar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 32px 10px;
  border-bottom: 1px solid #f4f4f5;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(8px);
}

.notion-detail-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 24px;
  padding: 22px 32px 32px;
}

.notion-article {
  min-width: 0;
}

.notion-article-title {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  margin-bottom: 18px;
}
.notion-article-title h1 {
  overflow-wrap: anywhere;
}

.history-type-view {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: -8px 0 18px 44px;
}

.history-type-panel {
  margin-top: 12px;
  margin-left: 4px;
  padding: 14px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
}

.history-type-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.history-type-option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
  padding: 7px 10px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fafafa;
  color: #52525b;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.12s, background 0.12s, color 0.12s;
}
.history-type-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.history-type-option.checked {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1d4ed8;
}

.history-type-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 1px solid #d4d4d8;
  border-radius: 4px;
  background: #fff;
  color: #2563eb;
  flex-shrink: 0;
}

.notion-comment-rail {
  position: sticky;
  top: 72px;
  align-self: start;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  border-left: 1px solid #f4f4f5;
  padding-left: 20px;
}

.ai-summary-box {
  margin: 0 0 20px;
  padding: 14px 16px;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  background: #eff6ff;
}

.notion-block-view {
  padding-top: 4px;
}

.notion-system-props {
  border-top: 1px solid #f4f4f5;
  margin-top: 18px;
  padding-top: 12px;
}

.notion-attachments {
  margin-top: 24px;
  padding: 16px;
  border-radius: 8px;
  background: #fafafa;
}

.notion-edit-title,
.notion-blocks-area,
.notion-edit-attachments {
  padding-left: 24px;
  padding-right: 24px;
}

.notion-edit-title {
  padding-top: 18px;
  padding-bottom: 10px;
}

.notion-blocks-area {
  padding-top: 10px;
  padding-bottom: 18px;
}

.notion-edit-attachments {
  padding-bottom: 32px;
}

@media (max-width: 1280px) {
  .notion-detail-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .notion-comment-rail {
    position: static;
    max-height: none;
    overflow: visible;
    border-left: 0;
    border-top: 1px solid #f4f4f5;
    padding-left: 0;
    padding-top: 20px;
  }
}
@media (max-width: 1024px) {
  .notion-workspace {
    grid-template-columns: 1fr;
  }
  .notion-list-pane,
  .notion-detail-pane {
    position: static;
    max-height: none;
  }
}
@media (max-width: 640px) {
  .notion-detail-toolbar,
  .notion-edit-toolbar,
  .notion-detail-grid,
  .notion-edit-title,
  .notion-blocks-area,
  .notion-edit-attachments {
    padding-left: 18px;
    padding-right: 18px;
  }
  .notion-list-header {
    flex-direction: column;
  }
  .notion-article-title {
    align-items: flex-start;
    flex-wrap: wrap;
  }
}
.notion-table-header {
  background: #fafafa;
  border-radius: 6px 6px 0 0;
}

.notion-table-row:last-child {
  border-bottom: none;
}
.notion-table-row:hover {
  background-color: #f9fafb;
}

.notion-table-body {
  border: 1px solid #e4e4e7;
  border-top: none;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}

.notion-cover {
  height: 200px;
  background-size: cover;
  background-position: center;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
}

.notion-cover-edit {
  min-height: 32px;
}

.notion-page-view,
.notion-page-edit {
  overflow-y: visible;
  padding-bottom: 32px;
}

.notion-view-content,
.notion-edit-content {
  min-height: 200px;
}

.notion-properties .notion-properties-header {
  padding: 4px 0;
}
.notion-properties .notion-toggle-icon {
  display: inline-block;
  transition: transform 0.15s ease;
}
.notion-properties .notion-toggle-icon.collapsed {
  transform: rotate(-90deg);
}

.notion-prop-row {
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 4px 0;
}

.notion-prop-label {
  width: 140px;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 500;
  color: #71717a;
}

.notion-prop-value {
  flex: 1;
  font-size: 13px;
  color: #27272a;
}

.block-inserter-zone {
  position: relative;
  margin: 2px 0;
  min-height: 8px;
}
.block-inserter-zone .block-inserter-inner {
  display: flex;
  align-items: center;
  opacity: 1;
  transition: opacity 0.15s;
}
.block-inserter-zone .block-inserter-line {
  flex: 1;
  height: 1px;
  background: #d4d4d8;
}
.block-inserter-zone .block-inserter-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid #d4d4d8;
  background: #fff;
  color: #a1a1aa;
  cursor: pointer;
  margin: 0 6px;
  flex-shrink: 0;
  transition: all 0.15s;
}
.block-inserter-zone .block-inserter-btn:hover {
  color: #2563eb;
  border-color: #2563eb;
  background: #eff6ff;
}

.block-add-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
  background: #fff;
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  width: 200px;
  padding: 4px 0;
  margin-top: 4px;
}

.block-add-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  cursor: pointer;
  transition: background 0.1s;
}
.block-add-item:hover {
  background: #f4f4f5;
}

.block-add-divider {
  border-top: 1px solid #e4e4e7;
  margin: 4px 0;
}

.notion-block-wrapper {
  position: relative;
  margin: 4px 0;
}
.notion-block-wrapper .notion-block-actions {
  position: absolute;
  top: 4px;
  right: -4px;
  transform: translateX(100%);
  display: flex;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.15s;
  z-index: 10;
}
.notion-block-wrapper:hover .notion-block-actions {
  opacity: 1;
}
.notion-block-wrapper .block-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: none;
  border-radius: 4px;
  color: #a1a1aa;
  cursor: pointer;
  transition: all 0.15s;
}
.notion-block-wrapper .block-action-btn:hover {
  color: #52525b;
  background: #f4f4f5;
}
.notion-block-wrapper .block-action-btn.block-action-delete:hover {
  color: #ef4444;
  background: #fef2f2;
}

.notion-content-block {
  min-height: 420px;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 8px 0;
  transition: border-color 0.15s;
}
.notion-content-block:focus-within {
  border-color: #e4e4e7;
}
.notion-content-block .notion-editor-block {
  display: block;
  min-height: 400px;
}
.notion-content-block ::ng-deep .notion-editor-wrapper,
.notion-content-block ::ng-deep .notion-editor,
.notion-content-block ::ng-deep .tiptap {
  min-height: 400px;
}

.notion-prop-row-edit {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 4px 0;
  border-bottom: 1px solid #f4f4f5;
}
.notion-prop-row-edit:last-of-type {
  border-bottom: none;
}

.notion-prop-label-edit {
  width: 120px;
  flex-shrink: 0;
}
.notion-prop-label-edit .prop-label-input {
  width: 100%;
  border: none;
  border-bottom: 1px dashed #d4d4d8;
  outline: none;
  font-size: 13px;
  font-weight: 500;
  color: #71717a;
  padding: 4px 0;
  background: transparent;
}
.notion-prop-label-edit .prop-label-input:focus {
  border-bottom-color: #2563eb;
}
.notion-prop-label-edit .prop-label-text {
  font-size: 13px;
  font-weight: 500;
  color: #71717a;
}

.notion-prop-value-edit {
  flex: 1;
  min-width: 0;
}
.notion-prop-value-edit .prop-text-input {
  width: 100%;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 13px;
  color: #27272a;
  outline: none;
  background: #fafafa;
  transition: border-color 0.15s, background 0.15s;
}
.notion-prop-value-edit .prop-text-input:focus {
  border-color: #2563eb;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}
.notion-prop-value-edit .prop-text-input::placeholder {
  color: #a1a1aa;
}
.notion-prop-value-edit .prop-date-input {
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 13px;
  color: #27272a;
  outline: none;
  background: #fafafa;
  transition: border-color 0.15s;
}
.notion-prop-value-edit .prop-date-input:focus {
  border-color: #2563eb;
  background: #fff;
}

.icon-picker-dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 50;
  background: #fff;
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  width: 280px;
}
.icon-picker-dropdown.show {
  display: block;
}

.notion-content p {
  margin: 0.4em 0;
  line-height: 1.8;
}
.notion-content h2 {
  font-size: 1.5em;
  font-weight: 700;
  margin-top: 1.5em;
  margin-bottom: 0.4em;
  color: #18181b;
}
.notion-content h3 {
  font-size: 1.2em;
  font-weight: 600;
  margin-top: 1.2em;
  margin-bottom: 0.3em;
  color: #27272a;
}
.notion-content blockquote {
  border-left: 3px solid #e4e4e7;
  padding-left: 16px;
  color: #71717a;
  margin: 1em 0;
}
.notion-content img {
  max-width: 100%;
  border-radius: 8px;
  margin: 1em 0;
}
.notion-content table {
  border-collapse: collapse;
  width: 100%;
  margin: 1em 0;
}
.notion-content th, .notion-content td {
  border: 1px solid #e4e4e7;
  padding: 8px 12px;
  text-align: left;
}
.notion-content th {
  background: #fafafa;
  font-weight: 600;
}
.notion-content code {
  background: #f4f4f5;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.9em;
}`],
})
export class PortalLpsysadminWidgetNotionPageComponent implements OnInit, OnDestroy {
    @Input() company: any;
    @Input() category: any;
    @Input() noteType: string = 'company_comment';

    public list: any[] = [];
    public loaded: boolean = false;

    // Mode: 'list' | 'view' | 'edit'
    public mode: string = 'list';
    public selectedItem: any = null;
    public summaryText: string = '';
    public summaryLoading: boolean = false;
    public summaryError: string = '';
    private readonly summaryThreshold: number = 900;

    // Edit state
    public editTitle: string = '';
    public editAttachments: any[] = [];
    public editIcon: string = '📄';
    public editCover: string = '';
    public editGrade: string = '';
    public editHistoryTypes: string[] = [];
    public isNewEntry: boolean = false;

    // Grade
    public gradeOptions = [
        { value: '', label: '-', color: '' },
        { value: 'S', label: 'S', color: 'bg-blue-100 text-blue-700 border-blue-300' },
        { value: 'A', label: 'A', color: 'bg-emerald-100 text-emerald-700 border-emerald-300' },
        { value: 'B', label: 'B', color: 'bg-yellow-100 text-yellow-700 border-yellow-300' },
        { value: 'C', label: 'C', color: 'bg-orange-100 text-orange-700 border-orange-300' },
        { value: 'D', label: 'D', color: 'bg-red-100 text-red-700 border-red-300' },
    ];

    public gradeStyle: any = {
        'S': 'bg-blue-100 text-blue-700',
        'A': 'bg-emerald-100 text-emerald-700',
        'B': 'bg-yellow-100 text-yellow-700',
        'C': 'bg-orange-100 text-orange-700',
        'D': 'bg-red-100 text-red-700',
    };

    public historyTypeOptions: string[] = ['미팅', '통화', '공문', '동의서', '이메일'];
    private approvalHistoryTypes: string[] = ['공문', '동의서'];

    // Block-based editing
    // Each block: { id, type: 'content'|'property', content?, key?, value?, propType?, options? }
    public editBlocks: any[] = [];
    public addMenuIndex: number = -1;
    private blockIdCounter: number = 0;

    // Property templates
    public propertyTemplates: any[] = [
        { key: '분류', type: 'select', icon: '🏷️', options: ['미팅', '통화', '공문', '동의서', '이메일', '기타'] },
        { key: '담당자', type: 'text', icon: '👤' },
        { key: '날짜', type: 'date', icon: '📅' },
        { key: '메모', type: 'text', icon: '📝' },
        { key: '태그', type: 'text', icon: '🔖' },
    ];

    // Icon picker
    public showIconPicker: boolean = false;
    public pageIcons: string[] = ['📄', '📝', '📋', '📊', '📈', '📉', '💰', '🏢', '🎯', '💡', '🔍', '📌', '⭐', '🚀', '💼', '📁', '🗂️', '📑', '🔑', '💎'];

    // Properties toggle (view mode)
    public propertiesCollapsed: boolean = false;

    // Pagination
    public page: number = 1;
    public pageSize: number = 20;
    public hasMore: boolean = false;

    private autoSaveTimer: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    ngOnDestroy() {
        this.clearAutoSave();
    }

    /* ──────── Block ID ──────── */
    private genBlockId(): string {
        return 'blk_' + (++this.blockIdCounter) + '_' + Date.now();
    }

    public trackByBlockId(index: number, block: any): string {
        return block.id;
    }

    /* ──────── Data Loading ──────── */
    public async load(reset: boolean = true) {
        if (reset) this.page = 1;
        try {
            const { code, data } = await wiz.call("search", {
                company_id: this.company.id,
                note_type: this.noteType,
                page: this.page,
                dump: this.pageSize,
            });
            if (code === 200) {
                if (reset) {
                    this.list = data.rows || data;
                } else {
                    const rows = data.rows || data;
                    this.list = [...this.list, ...rows];
                }
                this.hasMore = (data.rows || data).length >= this.pageSize;
            }
        } catch (e) {
            console.error('[notion-page] load error:', e);
            this.list = [];
        }
        this.loaded = true;
        await this.service.render();
    }

    public async loadMore() {
        this.page++;
        await this.load(false);
    }

    /* ──────── Mode Switching ──────── */
    public async openItem(item: any) {
        this.selectedItem = item;
        this.parseItemContent(item);
        this.mode = 'view';
        this.resetSummaryState();
        await this.service.render();
        await this.loadSummaryForItem(item);
    }

    public async backToList() {
        this.clearAutoSave();
        this.mode = 'list';
        this.selectedItem = null;
        this.editTitle = '';
        this.editBlocks = [];
        this.editAttachments = [];
        this.editIcon = '📄';
        this.editCover = '';
        this.editGrade = '';
        this.editHistoryTypes = [];
        this.isNewEntry = false;
        this.showIconPicker = false;
        this.addMenuIndex = -1;
        this.resetSummaryState();
        await this.load();
    }

    /* ──────── New Entry ──────── */
    public async openNewEntry() {
        this.isNewEntry = true;
        this.editTitle = '';
        this.editBlocks = [
            { id: this.genBlockId(), type: 'content', content: null }
        ];
        this.editAttachments = [];
        this.editIcon = '📄';
        this.editCover = '';
        this.editGrade = '';
        this.editHistoryTypes = [];
        this.selectedItem = null;
        this.showIconPicker = false;
        this.addMenuIndex = -1;
        this.resetSummaryState();
        this.mode = 'edit';
        await this.service.render();
    }

    /* ──────── Edit ──────── */
    public async startEdit() {
        if (!this.selectedItem) return;
        this.isNewEntry = false;
        this.editTitle = this.selectedItem.extra?.title || '';
        this.editAttachments = [...(this.selectedItem.extra?.attachments || [])];
        this.editIcon = this.selectedItem.extra?.icon || '📄';
        this.editCover = this.selectedItem.extra?.cover || '';
        this.editGrade = this.selectedItem.grade || '';
        this.editHistoryTypes = this.getItemHistoryTypes(this.selectedItem);
        this.showIconPicker = false;
        this.addMenuIndex = -1;

        // Load blocks
        if (this.selectedItem.extra?.blocks?.length) {
            this.editBlocks = this.selectedItem.extra.blocks.map((b: any) => ({
                ...b,
                id: b.id || this.genBlockId(),
            }));
        } else {
            // Migrate from old format
            this.editBlocks = [];
            if (this.selectedItem.extra?.properties?.length) {
                for (const p of this.selectedItem.extra.properties) {
                    this.editBlocks.push({
                        id: this.genBlockId(),
                        type: 'property',
                        key: p.key,
                        value: p.value,
                        propType: p.type,
                        options: p.options,
                    });
                }
            } else if (this.selectedItem.extra?.category) {
                const tpl = this.propertyTemplates.find(t => t.key === '분류');
                this.editBlocks.push({
                    id: this.genBlockId(),
                    type: 'property',
                    key: '분류',
                    value: this.selectedItem.extra.category,
                    propType: 'select',
                    options: tpl?.options || [],
                });
            }
            this.parseItemContent(this.selectedItem);
            this.editBlocks.push({
                id: this.genBlockId(),
                type: 'content',
                content: this.selectedItem._parsedContent || null,
            });
        }

        this.mode = 'edit';
        await this.service.render();
    }

    public onBlockContentChange(index: number, json: any) {
        if (this.editBlocks[index]) {
            this.editBlocks[index].content = json;
            this.resetAutoSave();
        }
    }

    private resetAutoSave() {
        this.clearAutoSave();
        this.autoSaveTimer = setTimeout(() => {
            if (this.mode === 'edit' && !this.isNewEntry) this.saveEdit(true);
        }, 30000);
    }

    private clearAutoSave() {
        if (this.autoSaveTimer) {
            clearTimeout(this.autoSaveTimer);
            this.autoSaveTimer = null;
        }
    }

    public async saveEdit(silent: boolean = false): Promise<boolean> {
        this.clearAutoSave();

        // Merge all content blocks into one doc for backward compat
        const contentBlocks = this.editBlocks.filter(b => b.type === 'content');
        let mergedContent = '';
        if (contentBlocks.length > 0) {
            const mergedDoc: any = { type: 'doc', content: [] };
            for (const cb of contentBlocks) {
                if (cb.content?.content) {
                    mergedDoc.content.push(...cb.content.content);
                }
            }
            if (mergedDoc.content.length > 0) {
                mergedContent = JSON.stringify(mergedDoc);
            }
        }

        if (!mergedContent && !this.editTitle.trim()) {
            if (!silent) await this.alert("내용을 입력해주세요.");
            return false;
        }

        let existingExtra: any = {};
        if (!this.isNewEntry && this.selectedItem?.extra) {
            existingExtra = { ...this.selectedItem.extra };
        }

        // Extract properties for backward compat
        const properties = this.editBlocks
            .filter(b => b.type === 'property')
            .map(b => ({ key: b.key, value: b.value, type: b.propType, options: b.options }));
        const categoryProp = properties.find(p => p.key === '분류');
        const categoryValue = categoryProp?.value || this.editHistoryTypes[0] || '';

        // Save blocks (full ordered structure)
        const blocksToSave = this.editBlocks.map(b => {
            if (b.type === 'content') {
                return { id: b.id, type: 'content', content: b.content };
            }
            return { id: b.id, type: 'property', key: b.key, value: b.value, propType: b.propType, options: b.options };
        });

        let data: any = {
            content: mergedContent,
            company_id: this.company.id,
            note_type: this.noteType,
            grade: this.editGrade,
            extra: {
                ...existingExtra,
                title: this.editTitle || '',
                icon: this.editIcon || '📄',
                cover: this.editCover || '',
                category: categoryValue,
                history_types: [...this.editHistoryTypes],
                properties: properties,
                blocks: blocksToSave,
                content_type: 'tiptap',
                attachments: this.editAttachments,
            },
        };

        if (!this.isNewEntry && this.selectedItem) {
            data.id = this.selectedItem.id;
        }

        const { code, data: resData } = await wiz.call("update", { data: JSON.stringify(data) });
        if (code === 200) {
            if (!silent) await this.alert('저장되었습니다', 'success');
            const savedId = resData?.id || this.selectedItem?.id;
            await this.load();
            if (savedId) {
                const found = this.list.find((i: any) => i.id === savedId);
                if (found) {
                    await this.openItem(found);
                    return true;
                }
            }
            this.mode = 'list';
            this.isNewEntry = false;
            return true;
        } else if (!silent) {
            await this.alert('저장에 실패했습니다.');
        }
        return false;
    }

    public async cancelEdit() {
        this.clearAutoSave();
        this.showIconPicker = false;
        this.addMenuIndex = -1;
        if (this.isNewEntry) {
            await this.backToList();
        } else {
            this.mode = 'view';
            await this.service.render();
        }
    }

    /* ──────── Block Operations ──────── */
    public availableTemplates(): any[] {
        const usedKeys = new Set(
            this.editBlocks.filter(b => b.type === 'property').map(b => b.key)
        );
        return this.propertyTemplates.filter(t => !usedKeys.has(t.key));
    }

    public async toggleAddMenu(index: number) {
        this.addMenuIndex = this.addMenuIndex === index ? -1 : index;
        await this.service.render();
    }

    public async insertContentBlock(atIndex: number) {
        this.editBlocks.splice(atIndex, 0, {
            id: this.genBlockId(),
            type: 'content',
            content: null,
        });
        this.addMenuIndex = -1;
        await this.service.render();
    }

    public async insertPropertyBlock(atIndex: number, template: any) {
        this.editBlocks.splice(atIndex, 0, {
            id: this.genBlockId(),
            type: 'property',
            key: template.key,
            value: '',
            propType: template.type,
            options: template.options ? [...template.options] : undefined,
        });
        this.addMenuIndex = -1;
        await this.service.render();
    }

    public async insertCustomPropertyBlock(atIndex: number) {
        this.editBlocks.splice(atIndex, 0, {
            id: this.genBlockId(),
            type: 'property',
            key: '',
            value: '',
            propType: 'text',
        });
        this.addMenuIndex = -1;
        await this.service.render();
    }

    public async removeBlock(index: number) {
        this.editBlocks.splice(index, 1);
        await this.service.render();
    }

    public async moveBlockUp(index: number) {
        if (index <= 0) return;
        const temp = this.editBlocks[index];
        this.editBlocks[index] = this.editBlocks[index - 1];
        this.editBlocks[index - 1] = temp;
        await this.service.render();
    }

    public async moveBlockDown(index: number) {
        if (index >= this.editBlocks.length - 1) return;
        const temp = this.editBlocks[index];
        this.editBlocks[index] = this.editBlocks[index + 1];
        this.editBlocks[index + 1] = temp;
        await this.service.render();
    }

    public async setBlockPropertyValue(index: number, value: string) {
        const block = this.editBlocks[index];
        if (block.propType === 'select' && block.value === value) {
            block.value = '';
        } else {
            block.value = value;
        }
        await this.service.render();
    }

    /* ──────── History Types / Approval ──────── */
    public getItemHistoryTypes(item: any): string[] {
        const extra = item?.extra || {};
        if (Array.isArray(extra.history_types)) {
            return extra.history_types.filter((type: string) => this.historyTypeOptions.includes(type));
        }
        if (extra.category && this.historyTypeOptions.includes(extra.category)) {
            return [extra.category];
        }
        return [];
    }

    public hasHistoryType(type: string): boolean {
        return this.editHistoryTypes.includes(type);
    }

    public async toggleHistoryType(type: string) {
        if (this.hasHistoryType(type)) {
            this.editHistoryTypes = this.editHistoryTypes.filter(t => t !== type);
        } else {
            this.editHistoryTypes = [...this.editHistoryTypes, type];
        }
        this.resetAutoSave();
        await this.service.render();
    }

    public requiresApproval(): boolean {
        return this.editHistoryTypes.some(type => this.approvalHistoryTypes.includes(type));
    }

    public requiresApprovalForItem(item: any): boolean {
        return this.getItemHistoryTypes(item).some(type => this.approvalHistoryTypes.includes(type));
    }

    private getApprovalDraftType(): string {
        const types = this.mode === 'edit'
            ? this.editHistoryTypes
            : this.getItemHistoryTypes(this.selectedItem);
        if (types.includes('동의서')) return '동의서';
        if (types.includes('공문')) return '공문';
        return '';
    }

    public async openApprovalDraft() {
        const approvalType = this.getApprovalDraftType();
        if (!approvalType) {
            await this.service.href('/admin/system/approval/draft/new');
            return;
        }
        const sourceTitle = this.mode === 'edit' ? this.editTitle : this.getTitle(this.selectedItem);

        if (this.mode === 'edit') {
            const saved = await this.saveEdit(true);
            if (!saved) {
                await this.alert('글 저장 후 기안문을 올려주세요.');
                return;
            }
        }

        let nextHref = '';
        await this.service.loading.show();
        try {
            const { code, data, message } = await wiz.call("create_approval_draft", {
                company_id: this.company?.id || this.company?.registed_number,
                note_id: this.selectedItem?.id || '',
                note_type: this.noteType,
                approval_type: approvalType,
                title: sourceTitle || this.getTitle(this.selectedItem),
            });
            await this.service.loading.hide();

            if (code === 200 && data?.href) {
                nextHref = data.href;
            } else {
                await this.alert(message || data?.message || '결재 기안 생성에 실패했습니다.');
            }
        } catch (e) {
            await this.service.loading.hide();
            console.error('[notion-page] approval draft error:', e);
            await this.alert('결재 기안 생성에 실패했습니다.');
        }

        if (nextHref) {
            await this.service.href(nextHref);
        }
    }

    /* ──────── Icon Picker ──────── */
    public async selectIcon(icon: string) {
        this.editIcon = icon;
        this.showIconPicker = false;
        await this.service.render();
    }

    public async toggleIconPicker() {
        this.showIconPicker = !this.showIconPicker;
        await this.service.render();
    }

    /* ──────── Properties Toggle (view mode) ──────── */
    public async toggleProperties() {
        this.propertiesCollapsed = !this.propertiesCollapsed;
        await this.service.render();
    }

    /* ──────── Cover Image ──────── */
    public async uploadCover() {
        let files = await this.service.file.select({ accept: 'image/*' });
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        let fd = new FormData();
        fd.append('upload', files[0]);
        const { url } = await this.service.file.upload('/file/upload', fd, () => { });
        this.editCover = url;
        await this.service.loading.hide();
        await this.service.render();
    }

    public async removeCover() {
        this.editCover = '';
        await this.service.render();
    }

    /* ──────── File Upload ──────── */
    public async uploadFile() {
        let files = await this.service.file.select();
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            fd.append('upload', files[i]);
            const { url } = await this.service.file.upload('/file/upload', fd, () => { });
            this.editAttachments.push({ name: files[i].name, url: url });
        }
        await this.service.loading.hide();
        await this.service.render();
    }

    public async removeFile(file: any) {
        const idx = this.editAttachments.indexOf(file);
        if (idx > -1) this.editAttachments.splice(idx, 1);
        await this.service.render();
    }

    /* ──────── Delete ──────── */
    public async deleteItem(item?: any) {
        const target = item || this.selectedItem;
        if (!target) return;
        let res: any = await this.alert("정말로 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        await wiz.call("delete", { id: target.id, note_type: this.noteType });
        await this.backToList();
    }

    /* ──────── Content Parsing ──────── */
    private parseItemContent(item: any) {
        if (item.extra?.content_type === 'tiptap' && item.content) {
            try {
                item._parsedContent = JSON.parse(item.content);
            } catch {
                item._parsedContent = null;
            }
        } else {
            item._parsedContent = null;
        }
    }

    public isLegacyHtml(item: any): boolean {
        return item && item.extra?.content_type !== 'tiptap';
    }

    /* ──────── AI Summary ──────── */
    private resetSummaryState() {
        this.summaryText = '';
        this.summaryLoading = false;
        this.summaryError = '';
    }

    private async loadSummaryForItem(item: any) {
        const plainText = this.getItemPlainText(item);
        if (!item?.id || plainText.length < this.summaryThreshold) return;

        const targetId = item.id;
        this.summaryLoading = true;
        await this.service.render();

        try {
            const { code, data, message } = await wiz.call("summarize", {
                id: item.id,
                note_type: this.noteType,
            });

            if (!this.selectedItem || this.selectedItem.id !== targetId || this.mode !== 'view') return;

            if (code === 200 && data?.summary) {
                this.summaryText = data.summary;
            } else if (code === 200 && data?.skipped) {
                this.summaryText = '';
            } else {
                this.summaryError = message || data?.message || 'AI 요약을 생성하지 못했습니다.';
            }
        } catch (e) {
            if (!this.selectedItem || this.selectedItem.id !== targetId || this.mode !== 'view') return;
            console.error('[notion-page] summary error:', e);
            this.summaryError = 'AI 요약을 생성하지 못했습니다.';
        }

        this.summaryLoading = false;
        await this.service.render();
    }

    private getItemPlainText(item: any): string {
        if (!item) return '';

        const blockTexts: string[] = [];
        if (item.extra?.blocks?.length) {
            for (const block of item.extra.blocks) {
                if (block.type === 'content' && block.content) {
                    blockTexts.push(this.extractText(block.content));
                }
            }
        }
        if (blockTexts.length > 0) return this.normalizeText(blockTexts.join(' '));

        if (item.extra?.content_type === 'tiptap' && item.content) {
            try {
                return this.normalizeText(this.extractText(JSON.parse(item.content)));
            } catch { }
        }

        return this.normalizeText((item.content || '').replace(/<[^>]+>/g, ' '));
    }

    private normalizeText(text: string): string {
        return (text || '').replace(/\s+/g, ' ').trim();
    }

    /* ──────── Helpers ──────── */
    public formatDate(date: string): string {
        if (!date) return '-';
        const d = date.substring(0, 10);
        return d === 'Invalid date' ? '-' : d;
    }

    public formatTime(date: string): string {
        if (!date || date.length < 16) return '';
        return date.substring(11, 16);
    }

    public getTitle(item: any) {
        if (item.extra?.title) return item.extra.title;
        if (item.extra?.content_type === 'tiptap') {
            try {
                const doc = JSON.parse(item.content);
                const text = this.extractText(doc);
                return text.length > 60 ? text.substring(0, 60) + '...' : text || '(제목 없음)';
            } catch { }
        }
        let text = (item.content || '').replace(/<[^>]+>/g, '').trim();
        return text.length > 60 ? text.substring(0, 60) + '...' : text || '(제목 없음)';
    }

    public getPreview(item: any) {
        if (item.extra?.content_type === 'tiptap') {
            try {
                const doc = JSON.parse(item.content);
                const text = this.extractText(doc);
                if (item.extra?.title) return text.length > 100 ? text.substring(0, 100) + '...' : text;
                return '';
            } catch { }
        }
        let text = (item.content || '').replace(/<[^>]+>/g, '').trim();
        if (item.extra?.title) return text.length > 100 ? text.substring(0, 100) + '...' : text;
        return '';
    }

    private extractText(node: any): string {
        if (!node) return '';
        if (node.text) return node.text;
        if (node.content) return node.content.map((n: any) => this.extractText(n)).join(' ');
        return '';
    }

    public getCategoryColor(cat: string): string {
        const colors: any = {
            '미팅': 'bg-blue-50 text-blue-700',
            '통화': 'bg-cyan-50 text-cyan-700',
            '공문': 'bg-indigo-50 text-indigo-700',
            '동의서': 'bg-rose-50 text-rose-700',
            '이메일': 'bg-sky-50 text-sky-700',
            '실사': 'bg-purple-50 text-purple-700',
            'IR': 'bg-amber-50 text-amber-700',
            '검토보고': 'bg-green-50 text-green-700',
            '계약': 'bg-red-50 text-red-700',
            '기타': 'bg-zinc-100 text-zinc-600',
        };
        return colors[cat] || 'bg-zinc-100 text-zinc-600';
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status,
        });
    }
}

export default PortalLpsysadminWidgetNotionPageComponent;